angular.module('dental')
.controller('VerifyCodeCtrl', ['$scope', '$window', 'formsStore', 'mainUtils', 'URL_PREFIX',
		function($scope, $window, formsStore, mainUtils, URL_PREFIX) {
	const ctrl = this;
	$scope.ctrl = ctrl;
	$scope.trustSrc = mainUtils.trustSrc;
	ctrl.errors = false;

	$scope.checkPassCode = function() {
		var code = $scope.access_code.toString();
		code = '0000'.slice(0, -code.length) + code;
		formsStore.verifyAccessCode({
			access_code:code,
			magic_front: $('input[name="magic"]').attr('value')
		}).then(function(data) {
			if (data.redirect_url) {
				$window.location.href = URL_PREFIX + '/' + data.redirect_url;
			} else {
				ctrl.errors = true;
			}
		});
	};
}]);
